<script setup>
defineProps({
  list: {
    type: Array,
    default: () => []
  },
  form: {
    type: String,
    default: 'square'
  }
})
const selected = defineModel('selected', { type: String, default: '' })
</script>

<template>
  <div
    class="toggle"
    :data-type="form"
  >
    <div
      v-for="item in list"
      :key="item.key"
      class="item"
      :data-selected="item.key === selected"
      @click="selected = item.key"
    >
      <p class="text">
        {{ item.text }}
      </p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.toggle {
  display: flex;
  padding: 5px;
  border-radius: 6px;
  background-color: #eef1f8;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .15) inset;
  .item {
    flex: 1;
    cursor: pointer;
    .text {
      margin-left: 1px;
      margin-right: 1px;
      font-size: 14px;
      font-weight: bold;
      line-height: 24px;
      border-radius: 3px;
      text-align: center;
      user-select: none;
    }
    &[data-selected=true] {
      pointer-events: none;
      .text {
        color: #fff;
        background-color: #438fec;
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .25);
      }
    }
    &:not(:last-child) {
      border-right: solid 1px rgba(#000, .1);
    }
  }
  &[data-type="round"] {
    border-radius: 90px;
    .item {
      .text {
        border-radius: 12px;
      }
    }
  }
  @media screen and (min-width: 830px) {
    .item {
      .text {
        transition: background-color .2s ease-in-out;
      }
      &:hover {
        .text {
          background-color: rgb(67 143 236 / 20%);
        }
      }
    }
  }
}
</style>
